import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import LoadPurchaseOrderDialog from './LoadPurchaseOrderDialog';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty('LoadPurchaseOrderForm')(state),
  values: getFormValues('LoadPurchaseOrderForm')(state),
  isValid: isValid('LoadPurchaseOrderForm')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('LoadPurchaseOrderForm'),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change('LoadPurchaseOrderForm', fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoadPurchaseOrderDialog);
